export const SkuCategoryList: string[] = [
  "상의",
  "바지",
  "스커트",
  "아우터",
  "원피스",
];

export const SkuCategoryDetailMap: Record<string, string[]> = {
  상의: ["오버핏", "레귤러핏", "슬림핏", "크롭", "AI 자동 분류"],
  바지: ["스키니", "스트레이트", "부츠컷", "와이드", "조거", "AI 자동 분류"],
  스커트: ["미니", "미디", "롱", "플레어", "AI 자동 분류"],
  아우터: ["오버핏", "레귤러핏", "크롭", "AI 자동 분류"],
  원피스: ["미니", "미디", "맥시", "슬림", "플레어", "AI 자동 분류"],
  "상하의 셋업": ["오버핏", "레귤러핏", "슬림핏", "AI 자동 분류"],
};

export type CategoryType = "Top" | "Pants" | "Outerwear" | "Skirt" | "Dress" | "Set";

export const CATEGORY_KO_TO_EN: Record<string, CategoryType> = {
  상의: "Top",
  바지: "Pants",
  아우터: "Outerwear",
  스커트: "Skirt",
  원피스: "Dress",
};

export const FIT_OPTIONS: Partial<Record<CategoryType, string[]>>  = {
  Top: ["slim", "nomal", "relax", "over","ai"],
  Pants: ["skinny", "straight", "flare", "wide", "jogger","ai"],
  Outerwear: ["slim", "nomal", "relax", "over","ai"],
};

export const LENGTH_OPTIONS: Partial<Record<CategoryType, string[]>> = {
  Top: ["cropped", "medium", "extended","ai"],
  Pants: ["short", "knees", "midi", "long","ai"],
  Outerwear: ["cropped", "regular", "thigh", "knee", "ankle","ai"],
  Skirt: ["short", "knees", "midi", "long","ai"],
  Dress: ["short", "knees", "midi", "long","ai"],
};

export const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const getEnglishCategory = (category: string): CategoryType => {
  if (category in LENGTH_OPTIONS || category in FIT_OPTIONS) {
    return capitalizeFirstLetter(category) as CategoryType;
  }
  return CATEGORY_KO_TO_EN[category] || "Top";
};

//=======================================================
// 
type SkuColorType = {
  name: string;
  color: string;
  strokeColor: string;
};

// /upload 색깔 선택에서 사용
export const SkuColorList: SkuColorType[] = [
  { name: "화이트", color: "#FFF", strokeColor: "#D1D5DB" },
  { name: "그레이", color: "#9CA3AF", strokeColor: "#6B7280" },
  { name: "차콜", color: "#36454F", strokeColor: "#2B373F" },
  { name: "블랙", color: "#171718", strokeColor: "#171718" },
  { name: "아이보리", color: "#FFFFF0", strokeColor: "#F5F5DC" },
  { name: "베이지", color: "#F5EFDC", strokeColor: "#F0E8CF" },
  { name: "라이트 핑크", color: "#FFC0CB", strokeColor: "#E9AFB9" },
  { name: "핑크", color: "#FF69B4", strokeColor: "#E264A3" },
  { name: "라이트 블루", color: "#ADD8E6", strokeColor: "#9DC9D7" },
  { name: "블루", color: "#0000CD", strokeColor: "#0000C2" },
  { name: "네이비", color: "#000080", strokeColor: "#06065D" },
  { name: "민트", color: "#CCEACE", strokeColor: "#C0E6C2" },
  { name: "그린", color: "#008000", strokeColor: "#006A00" },
  { name: "올리브 그린", color: "#6A7758", strokeColor: "#596449" },
  { name: "라이트 라일락", color: "#E6E6FA", strokeColor: "#D5D5F1" },
  { name: "퍼플", color: "#7B0CC0", strokeColor: "#680EA0" },
  { name: "레드", color: "#EF4444", strokeColor: "#E01F1F" },
  { name: "옐로우", color: "#F7EE15", strokeColor: "#E5DE32" },
  { name: "오렌지", color: "#FFA500", strokeColor: "#FF8C00" },
  { name: "라이트 브라운", color: "#DEB887", strokeColor: "#D5B285" },
  { name: "브라운", color: "#964B00", strokeColor: "#844200" },
  {
    name: "실버",
    color: "linear-gradient(225deg, #C0C0C0 16.67%, #FFF 50%, #A2A2A2 83.33%)",
    strokeColor: "#C0C0C0",
  },
  {
    name: "골드",
    color: "linear-gradient(225deg, #FFD700 16.67%, #FCFAF0 50.33%, #F1CE13 83.33%)",
    strokeColor: "#FFD700",
  },
];
